import { render, staticRenderFns } from "./CompanyShopTargetsSetting.vue?vue&type=template&id=8cc61f1c&scoped=true"
import script from "./CompanyShopTargetsSetting.vue?vue&type=script&lang=js"
export * from "./CompanyShopTargetsSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyShopTargetsSetting.vue?vue&type=style&index=0&id=8cc61f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc61f1c",
  null
  
)

export default component.exports